import React from 'react';
import { ILxsContactPageCardProps } from '../lxs-contact-page.data';
import { mapRoleCodeToText } from '../../../utilities/map-role-code-to-text';
import ResponsibilityPill from './responsibility-pill';
import { mapBusinessUnitToText } from '../../../utilities/map-business-unit-to-text';

const ContactCard: React.FC<ILxsContactPageCardProps> = ({ resources, CLASS_NAME, partner }) => {
    const uniqueSalesAreas = Array.from(new Map(partner.SalesAreas.map(area => [`${area.SalesOrg}-${area.Division}`, area])).values());

    const responsibilityItems = [
        {
            label: resources.contactPageSalesOrgCardLabel,
            value: Array.from(new Set(uniqueSalesAreas.map(area => area.SalesOrgText)))
        },
        {
            label: resources.contactPageBusinessUnitCardLabel,
            value: Array.from(new Set(uniqueSalesAreas.map(area => mapBusinessUnitToText(area.Division))))
        }
    ];

    return (
        <div className={`${CLASS_NAME}__card`}>
            <div className={`${CLASS_NAME}__card-partner-information`}>
                <span className={`${CLASS_NAME}__card-partner-role`}>{mapRoleCodeToText(partner.Role, resources)}</span>
                <h3 className={`${CLASS_NAME}__card-partner-name`}>{partner.Name}</h3>
            </div>
            <ResponsibilityPill CLASS_NAME={CLASS_NAME} items={responsibilityItems} />
            <div className={`${CLASS_NAME}__card-contact`}>
                <a href={`mailto:${partner.Email}`} className={`msc-cta__secondary ${CLASS_NAME}__card-contact-message-button`}>
                    {resources.contactPageMessageLabel}
                </a>
            </div>
        </div>
    );
};

export default ContactCard;
